import { render, staticRenderFns } from "./ConfigKakaoSendKeyPopup.vue?vue&type=template&id=4f652cda&"
import script from "./ConfigKakaoSendKeyPopup.vue?vue&type=script&lang=js&"
export * from "./ConfigKakaoSendKeyPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports